import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AcessoNegadoContentComponent } from "./acesso-negado-content.component";

@Injectable({
  providedIn: "root",
})
export class AcessoNegadoService {
  private modalRef?: BsModalRef;

  constructor(
    private modalService: BsModalService,
    private router: Router
  ) {}

  exibir(): void {
    this.modalRef = this.modalService.show(AcessoNegadoContentComponent, {
      ignoreBackdropClick: true,
      class: "modal-dialog-centered",
    });

    this.modalRef.content.onFechar = () => {
      this.modalRef?.hide();
      this.router.navigate(["/live-desktop"]);
    };
  }
}
